interface SvgInterface {
    className?: string;
}
export function RepeatAllIcon({className = ''}: SvgInterface) {
    return <svg className={className} height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h48v48H0z" fill="none"/>
        <path d="M14 14h20v6l8-8-8-8v6H10v12h4v-8zm20 20H14v-6l-8 8 8 8v-6h24V26h-4v8z"/>
    </svg>;
}